import React, { useState, useEffect } from 'react';
import { Link, useLocation, useHistory } from 'react-router-dom';
import ChildInvestorAcademyCommon from '../../../../../components/common/InvestorAcademyCommon/ChildInvestorAcademyCommon';
import "../../common.css";
import "../../investorAcademy.css";



const InterestRates = (props) => {
    useEffect(() => {
        window.scrollTo(0, 0)
      }, [])
    const location = useLocation();
    const history = useHistory();

    return (
        <div id="investor_academy">
            <div className="imgbg" />
            <div className="mainbg"></div>

            <div id="main">
                <div id="maintable" className='liquidity_sec Common_warrent' style={{ display: 'table', width: '100%', tableLayout: 'fixed' }}>
                    <div style={{ display: 'table-row' }}>
                        <div id="leftbar" className="hidden-xs" style={{ display: 'table-cell', width: '80px' }} />
                        <div id="maincontainer" style={{ display: 'table-cell', width: '100%' }}>
                            <div id="mainnav">
                                <table style={{ width: '100%', tableLayout: 'fixed', borderBottom: '1px solid #353223' }}>
                                    <tbody><tr>
                                        <td width="20%" style={{ textAlign: 'left', visibility: 'hidden' }}>
                                            <table className="hasprev hidden-xs" style={{ width: '100%', height: '100%', tableLayout: 'fixed' }}>
                                                <tbody><tr>
                                                    <td width="33px"><div className="prev left" /></td>
                                                    <td>
                                                        <div className="prevlbl left">
                                                            <div className="prevtitle " style={{ textAlign: 'left' }} />
                                                            <div className="prevname " style={{ textAlign: 'left' }}>Dividends</div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                </tbody></table>
                                        </td>
                                        <td width="60%" style={{ textAlign: 'center' }}>
                                            <div id="pagetitlediv" style={{ width: '365px', height: '100%', borderBottom: '1px solid #FFD843', margin: 'auto' }}>
                                                <div id="ptitle" style={{ fontFamily: 'HelveticaNeueThinCond', fontSize: '25px', color: 'white', letterSpacing: '1px' }}>How are Warrants priced?</div>
                                                <div id="pname" style={{ fontFamily: 'HelveticaNeueThinCond', fontSize: '30px', color: '#FFD843', letterSpacing: '1px', paddingTop: '5px', paddingBottom: '5px' }}>Interest Rates</div>
                                            </div>
                                        </td>
                                        <td width="20%" style={{ textAlign: 'right', visibility: 'hidden' }}>
                                            <table className="hasnext  hidden-xs" style={{ width: '100%', height: '100%', tableLayout: 'fixed' }}>
                                                <tbody><tr>
                                                    <td>
                                                        <div className="nextlbl right">
                                                            <div className="nexttitle " style={{ textAlign: 'right' }}>Next Topic</div>
                                                            <div className="nextname " style={{ textAlign: 'right' }}>Understanding the Warrant Structure</div>
                                                        </div>
                                                    </td>
                                                    <td width="33px"><div className="next right" /></td>
                                                </tr>
                                                </tbody></table>
                                        </td>
                                    </tr>
                                    </tbody></table>
                            </div>
                            <div id="maincontent" style={{ marginLeft: '10px', marginRight: '10px', paddingTop: '40px', marginBottom: '60px' }}>
                                <div id="mainscroll" style={{ height: '100%', overflowX: 'hidden', overflowY: 'auto', paddingLeft: '90px', paddingRight: '90px' }}>
                                    <div id="mainscrollcontent">
                                        <meta httpEquiv="Content-Type" content="text/html; charset=UTF-8" />
                                        {/*<link rel="stylesheet" href="css/common.css"/>*/}
                                        <title>Interest Rates</title>
                                        <div className="contentbox">
                                            <p>Interest rates will affect the price of a warrant through financial holding costs. Typically, when you buy a call warrant, issuers will hedge their position by buying the underlying share. This requires funding and, as such, when the cost of borrowing goes up as a result of rising interest rates, the price of a call warrant will also go up. The inverse is true for a put warrant.</p>
                                            <div className="imgholder11">
                                                <img style={{ maxWidth: '800px' }} src='/img/education/ir.png' alt="image" />
                                            </div>
                                            <div className="imgholder imgmask2">
                                                <img style={{ maxWidth: '800px' }} src='/img/education/ir_m (1).png' alt="image" />
                                            </div>
                                            <br /><br />
                                            <div className="tipholder">
                                                <div className="tipbox">
                                                    <h2 style={{ marginTop: '20px' }}>Helpful Tips</h2>
                                                    <ul>
                                                        <li><p>When choosing an appropriate warrant, investors should be more concerned with the first four factors. Generally, the last two factors – dividends and interest rates – have a smaller impact on the warrant price.</p></li>
                                                        <li><p>To estimate how each of the above factors can affect a warrant's price, you may use the Macquarie's warrant calculator, <Link target="_blank" to="/tools/warrantcalculator">click here</Link></p></li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div id="rightbar" className="hidden-xs" style={{ display: 'table-cell', width: '80px' }}>
                                </div>
                            </div>
                        </div>
                        <div id="rightbar" className="hidden-xs" style={{ display: 'table-cell', width: '80px' }}>
                        </div>
                    </div>
                </div>
            </div>

            <div
                id="bottom"
                style={{
                    position: "fixed",
                    width: "100%",
                    bottom: "0px",
                    height: "40px",
                    backgroundColor: "#101010",
                    zIndex: 10000,
                }}
            >
                <div
                    className="hidden-xs hidden-xxs"
                    style={{
                        display: "table",
                        width: "100%",
                        textAlign: "center",
                        color: "#8F8F8F",
                        fontSize: "11px",
                        lineHeight: "40px",
                    }}
                >
                    <div className='copyright_sec'>
                        Copyright (c) 2016 Macquarie Group Limited ABN 94 122 169 279. All rights
                        reserved.
                    </div>
                </div>
                <div
                    style={{
                        position: "absolute",
                        width: "46%",
                        height: "35px",
                        right: "10px",
                        bottom: "5px",
                    }}
                >
                    <table
                        className="hasnext"
                        style={{ width: "100%", height: "100%", tableLayout: "fixed" }}
                    >
                        <tbody>
                            <tr>
                                <td>
                                    <div className="nextlbl right">
                                        <div
                                            className="nextname "
                                            style={{ textAlign: "right", fontSize: "15px" }}
                                        >
                                        <Link to="/edu/understanding-warrant-structure">
                                            Understanding the Warrant Structure
                                            </Link>
                                        </div>
                                    </div>
                                </td>
                                <td width="33px">
                                <Link to="/edu/understanding-warrant-structure">
                                    <div className="next right" />
                                    </Link>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div
                    style={{
                        position: "absolute",
                        width: "46%",
                        height: "35px",
                        left: "10px",
                        bottom: "5px",
                    }}
                >
                    <table
                        className="hasprev"
                        style={{ width: "100%", height: "100%", tableLayout: "fixed" }}
                    >
                        <tbody>
                            <tr>
                                <td width="33px">
                                <Link to="/edu/how-are-warrant-priced/dividend">
                                    <div className="prev left" />
                                </Link>
                                </td>
                                <td>
                                    <div className="prevlbl left">
                                        <div
                                            className="prevname "
                                            style={{ textAlign: "left", fontSize: "15px" }}
                                        >
                                            <Link to="/edu/how-are-warrant-priced/dividend">
                                                Dividends
                                            </Link>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div id="dotbar" className="hidden-sm hidden-xs" style={{}}>
                {/* <div className="dbtn dbtn-seminarbtn">
                <Link
                    className="seminarbtn"
                    to="/education/seminar"
                    >
                    <img src='/img/education/button-static.png' alt="image" />
                    </Link>
                </div> */}
                <ChildInvestorAcademyCommon Location={location} Hist={history} />
            </div>

        </div>
    );
}
export default InterestRates;